import { initializeApp } from'firebase/app';
// Add the Firebase products that you want to use
import {getAuth, onAuthStateChanged, createUserWithEmailAndPassword, updateProfile,signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail, sendEmailVerification, signOut, updateEmail, EmailAuthProvider, reauthenticateWithCredential, updatePassword, deleteUser, applyActionCode, verifyPasswordResetCode, confirmPasswordReset} from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

class FirebaseAuthBackend {
    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            //firebase.initializeApp(firebaseConfig);    
            this.app = initializeApp(firebaseConfig); 
            const auth = getAuth(this.app);
            this.db = getFirestore(this.app);
            onAuthStateChanged(auth, user => {
                if (user) {
                    localStorage.setItem("authUser", JSON.stringify(user));
                } else {
                    localStorage.removeItem('authUser');
                }
            });
        }
    }

    getApp() {
        return this.app;
    }
    
    authCredentials(){
        return getAuth(this.app).currentUser;
    }

    /**
     * Registers the user with given details
     */
    registerUser(username, email, password) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-unused-vars
            const auth = getAuth(this.app);
            createUserWithEmailAndPassword(auth, email, password).then(() => {
                updateProfile(auth.currentUser,{displayName:username})
                resolve(auth.currentUser);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Login user with given details
     */
    loginUser(email, password,with_provider) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            if(!with_provider){
                signInWithEmailAndPassword(auth,email, password).then(() => {
                    var user = auth.currentUser;
                    localStorage.setItem("authUser", JSON.stringify(user));
                    resolve(user);
                }, (error) => {
                    reject(this._handleError(error));
                });
            } else {
                //console.log('with provider', with_provider)
                var provider = new GoogleAuthProvider();
                provider.addScope('profile');
                provider.addScope('email');
                signInWithPopup(auth, provider).then(function(result) {
                // This gives you a Google Access Token.
                //var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;
                localStorage.setItem("authUser", JSON.stringify(user));
                resolve(user);                
                }, (error) => {
                    console.log('loginUser error', error)
                    reject(this._handleError(error));
                });
            }

        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword(email) {
        return new Promise((resolve, reject) => { 
            const auth = getAuth(this.app);
            sendPasswordResetEmail(auth, email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Logout the user
     */
    logout() {
        return new Promise((resolve, reject) => { 
            const auth = getAuth(this.app);
            signOut(auth).then(() => {
                //console.log("logout");
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    setLoggeedInUser(user) {
        localStorage.setItem("authUser", JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser() {
        if (!localStorage.getItem('authUser'))
            return null;
        return JSON.parse(localStorage.getItem('authUser'));
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        // Return the whole error object so the caller can access error.code
        return error;
    }

   /**
     * Returns the user document data from Firestore
     */
   async getUserDocument() {
        const user = this.getAuthenticatedUser();
        if (!user) {
            console.error("No authenticated user found.");
            return null;
        }

        try {
            const userDocRef = doc(this.db, "users", user.uid); // Reference to the user's doc
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                return {
                    id: userDocSnap.id, // Include the doc ID
                    ...userDocSnap.data() // Get the doc data
                };
            } else {
                console.warn("User document not found.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching user document:", error);
            return null;
        }
    } 
    
    updateUserEmail(newEmail) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user) {
                return reject("No user currently authenticated.");
            }

            updateEmail(user, newEmail).then(() => {
                //console.log("Firebase Auth email updated successfully.");
                // Important: Update the user object in localStorage as well
                // Fetch the latest user data as updateEmail doesn't return it directly
                const updatedUser = auth.currentUser;
                localStorage.setItem("authUser", JSON.stringify(updatedUser));
                resolve(updatedUser); // Resolve with the updated user object
            }).catch((error) => {
                console.error("Error updating Firebase Auth email:", error);
                reject(this._handleError(error)); // Use existing error handler
            });
        });
    }

    /**
     * Re-authenticates the current user.
     * Needed for sensitive operations like email/password change if login wasn't recent.
     */
    reauthenticateUser(password) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user || !user.email) {
                return reject("User not found or email missing for re-authentication.");
            }

            const credential = EmailAuthProvider.credential(user.email, password);

            reauthenticateWithCredential(user, credential).then(() => {
                //console.log("User re-authenticated successfully.");
                resolve();
            }).catch((error) => {
                console.error("Re-authentication failed:", error);
                reject(this._handleError(error)); // Use existing error handler
            });
        });
    } 
    
    /**
     * Updates the authenticated user's password in Firebase Auth.
     * IMPORTANT: This should ONLY be called AFTER successful re-authentication.
     */
    updateUserPassword(newPassword) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user) {
                return reject("No user currently authenticated.");
            }

            updatePassword(user, newPassword).then(() => {
                //console.log("Firebase Auth password updated successfully.");
                resolve(); // Password updated
            }).catch((error) => {
                console.error("Error updating Firebase Auth password:", error);
                // Handle specific errors like weak password if needed
                if (error.code === 'auth/weak-password') {
                    reject('Password is too weak. Please choose a stronger password.');
                } else {
                    reject(this._handleError(error)); // Use existing error handler
                }
            });
        });
    }   
    
    /**
     * Sends a password reset email to the provided email address.
     */
    sendPasswordReset(email) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);

            if (!email) {
                return reject("Email address is required to send a password reset link.");
            }

            sendPasswordResetEmail(auth, email).then(() => {
                //console.log("Password reset email sent successfully to:", email);
                resolve(); // Email sent
            }).catch((error) => {
                console.error("Error sending password reset email:", error);
                // Handle specific errors if needed (e.g., user not found, though unlikely if called for logged-in user)
                reject(this._handleError(error)); // Use existing error handler
            });
        });
    }  
    
    /**
     * Sends an email verification to the current authenticated user.
     * @param {object} [actionCodeSettings] Optional Firebase action code settings
     * (custom redirect URL / handleCodeInApp).
     * @return {Promise<void>} Resolves when the verification email is sent.
     */
    sendVerificationEmail(actionCodeSettings) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user) {
                return reject("No user currently authenticated.");
            }

            sendEmailVerification(user, actionCodeSettings).then(() => {
                resolve();
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Applies an email action code (e.g. email verification) from the current
     * Firebase Auth instance.
     * @param {string} oobCode The one-time action code from the email link.
     * @return {Promise<void>} Resolves when the action code is applied.
     */
    applyVerificationCode(oobCode) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);

            if (!oobCode) {
                return reject("No action code provided.");
            }

            applyActionCode(auth, oobCode).then(() => {
                resolve();
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Verifies a password reset action code and returns the account email.
     * @param {string} oobCode The one-time action code from the email link.
     * @return {Promise<string>} Resolves with the account email on success.
     */
    verifyPasswordResetCode(oobCode) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);

            if (!oobCode) {
                return reject("No action code provided.");
            }

            verifyPasswordResetCode(auth, oobCode).then((email) => {
                resolve(email);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Confirms a password reset with a new password.
     * @param {string} oobCode The one-time action code from the email link.
     * @param {string} newPassword The new password to set.
     * @return {Promise<void>} Resolves when the password is updated.
     */
    confirmPasswordReset(oobCode, newPassword) {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);

            if (!oobCode) {
                return reject("No action code provided.");
            }

            confirmPasswordReset(auth, oobCode, newPassword).then(() => {
                resolve();
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Reloads the current user's profile from Firebase Auth (refreshes emailVerified).
     * @return {Promise<object>} Resolves with the refreshed user object.
     */
    reloadCurrentUser() {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user) {
                return reject("No user currently authenticated.");
            }

            user.reload().then(() => {
                resolve(user);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }
    
    /**
     * Deletes the currently authenticated user from Firebase Auth.
     * IMPORTANT: This should ONLY be called AFTER successful re-authentication.
     */
    deleteCurrentUser() {
        return new Promise((resolve, reject) => {
            const auth = getAuth(this.app);
            const user = auth.currentUser;

            if (!user) {
                return reject("No user currently authenticated to delete.");
            }

            deleteUser(user).then(() => {
                //console.log("Firebase Auth user deleted successfully.");
                resolve(); // User deleted
            }).catch((error) => {
                console.error("Error deleting Firebase Auth user:", error);
                // Handle specific errors if needed
                reject(this._handleError(error)); // Use existing error handler
            });
        });
    }   
    
    /**
     * Checks if the primary authentication method is email/password.
     */
    isPasswordProvider() {
        const auth = getAuth(this.app);
        const user = auth.currentUser;
        if (!user || !user.providerData || user.providerData.length === 0) {
            return false; // Or handle as needed, maybe default to true if unsure?
        }
        // Check if 'password' is listed as a provider ID
        return user.providerData.some(provider => provider.providerId === 'password');
    }    
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config 
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend.getApp();
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
};

export { initFirebaseBackend, getFirebaseBackend };